/** A minimal subscribable value (works with React's useSyncExternalStore). */
export interface Store<T> {
  get(): T;
  subscribe(cb: (value: T) => void): () => void;
}

export interface WritableStore<T> extends Store<T> {
  set(next: T): void;
  update(patch: Partial<T>): void;
}

export function createStore<T extends object>(initial: T): WritableStore<T> {
  let value = initial;
  const subs = new Set<(v: T) => void>();
  const set = (next: T) => {
    value = next;
    for (const cb of subs) cb(value);
  };
  return {
    get: () => value,
    subscribe(cb) {
      subs.add(cb);
      return () => void subs.delete(cb);
    },
    set,
    update(patch) {
      if (Object.entries(patch).every(([k, v]) => Object.is((value as Record<string, unknown>)[k], v))) return;
      set({ ...value, ...patch });
    },
  };
}
